import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const employeePositionDetailTableConfig = (): TableConfig => {
  return {
    useApiData: false, // Use variable data instead of API
    title: 'Lịch sử vị trí công việc',
    entityName: 'vị trí công việc',
    columns: [
      { field: 'position.name', header: 'Vị trí', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'department.name', header: 'Phòng ban', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'fromDate', header: 'Ngày bắt đầu', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'toDate', header: 'Ngày kết thúc', width: 'min-w-[120px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'status', header: 'Trạng thái', width: 'min-w-[120px]', sortable: true, type: 'tag', tagType: 'employeePositionStatus' },
      { field: 'probations', header: 'Tình trạng thử việc', width: 'min-w-[180px]', sortable: false, type: 'custom' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        icon: 'pi pi-user-minus',
        tooltip: 'Nghỉ việc',
        severity: 'warn',
        styleClass: 'p-button-warning p-button-text p-button-sm',
        onClick: PLACEHOLDER_FUNCTIONS.RETIRE
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      },
      {
        location: 'row',
        useDefaultStyle: 'delete',
        onClick: PLACEHOLDER_FUNCTIONS.DELETE,
        confirmMessage: 'Bạn có chắc chắn muốn xóa lịch sử công tác này?'
      },
    ]
  };
};
